import(/* webpackMode: "eager" */ "/app/app/[countryCode]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PageViewTracker"] */ "/app/components/gtm/PageViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/footer/links.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/footer/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/header/navbar/topnav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/header/topbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/script-manager/BodyScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/script-manager/HeadScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shared/RegionPromptBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/app/components/ui/languageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"fonts/index.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"fonts/index.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--inter-font\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./Proxima/proxima_nova_light.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"./Proxima/proxima_nova_regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./Proxima/proxima_nova_semibold.woff2\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"./Proxima/proxima_nova_bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"}],\"variable\":\"--proxima-font\",\"display\":\"swap\",\"adjustFontFallback\":false}],\"variableName\":\"proxima\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-lite-youtube-embed/dist/LiteYouTubeEmbed.css");
